import { render, staticRenderFns } from "./ComputerPackages.vue?vue&type=template&id=3fb27065&"
import script from "./ComputerPackages.vue?vue&type=script&lang=js&"
export * from "./ComputerPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports